import React, { FC } from 'react'
import cx from 'classnames'

import { LinkProps } from '../../Link'

import * as SC from './styled'

export type FooterProductProps = {
  className?: string
  title: string
  links: LinkProps[]
}

const FooterProduct: FC<FooterProductProps> = (props) => {
  const { className, title, links } = props

  return (
    <SC.Container className={cx(className)}>
      <SC.Column>
        <SC.Title>{title}</SC.Title>
        <SC.ListWrapper>
          {links.map((item, index) => (
            <SC.ListItem key={index}>
              <SC.Lk {...item} />
            </SC.ListItem>
          ))}
        </SC.ListWrapper>
      </SC.Column>
    </SC.Container>
  )
}

export default FooterProduct
